import { MessageTemplates } from '../../../../components';
import { SelectMessage } from '../../styled';

const MessageStep = ({ template, onTemplateChange }) => {
    return (
        <div className="content">
            <SelectMessage>
                {template && (
                    <span className='preview--message'>
                        {template?.text ? template?.text : template?.textFormatted}
                    </span>
                )}
                <div className='box--message--'>
                    <MessageTemplates
                        className='message--'
                        isTemplatesOpenSession={true}
                        onChange={onTemplateChange}
                    />
                </div>
            </SelectMessage>
        </div>
    );
};

export default MessageStep;